import React from "react";
import { Title } from "../open-title";
import { useTranslation } from "react-i18next";
// import LinkLine from "../open-linkline";
import classNames from "classnames";
import "./styles.less";

const Card = ({ title, desc, theme, image, imageEn, language, link }) => {
  return (
    <div
      className={classNames(
        "open-page-manual-card",
        `open-page-manual-card--${theme}`
      )}
      onClick={() => {
        window.open(link);
      }}
    >
      <img
        src={`${language.includes("en") ? imageEn : image}?t=${Date.now()}`}
        alt=""
      />
      <div className="open-page-manual-card-content">
        <div className="open-page-manual-card-content__title">
          {title}
          {/* <LinkLine /> */}
        </div>
        <div className="open-page-manual-card-content__desc">{desc}</div>
      </div>
    </div>
  );
};

export const ManualComponent = () => {
  const { t, i18n } = useTranslation();

  const cards = [
    {
      title: t("open.manual.b2b.title"),
      desc: t("open.manual.b2b.desc"),
      theme: "dark",
      image: "//files.authing.co/authing-website/open/b2b.png",
      imageEn: "//files.authing.co/authing-website/open/b2b-en.png",
      link: "https://steamory.feishu.cn/docx/XCr3dYj5NoP6SkxpQCecifDQnkc",
    },
    {
      title: t("open.manual.b2e.title"),
      desc: t("open.manual.b2e.desc"),
      theme: "light",
      image: "//files.authing.co/authing-website/open/b2e.png",
      imageEn: "//files.authing.co/authing-website/open/b2e-en.png",
      link: "https://steamory.feishu.cn/docx/GZPGdYzo4o740LxtZCYcQDUMnmf",
    },
    {
      title: t("open.manual.b2c.title"),
      desc: t("open.manual.b2c.desc"),
      theme: "dark",
      image: "//files.authing.co/authing-website/open/b2c.png",
      imageEn: "//files.authing.co/authing-website/open/b2c-en.png",
      link: "https://steamory.feishu.cn/docx/WkZyd6PwFoVHwuxExmPc9JkCntb",
    },
  ];

  return (
    <div className="open-page-manual">
      <Title
        title={t("open.manual.title")}
        desc={t("open.manual.desc")}
        theme="dark"
      />

      <div className="basic-column">
        <div className="open-page-manual-content">
          {cards.map((card) => {
            return <Card {...card} language={i18n.language} />;
          })}
        </div>
      </div>
    </div>
  );
};
